export default __webpack_public_path__ + "static/media/SteelDrum-vs.3efe878d.mp3";